<template>
  <v-container fluid class="pa-0 vendor-dashboard">
    <v-container fluid class="d-flex pa-0">
      <vendor-dashboard-overview
        :is-other="isOther"
        :stocks="stocks"
        :expenses="expenses"
      ></vendor-dashboard-overview>
    </v-container>
    <v-container
      fluid
      class="d-flex justify-center px-0 flex-wrap flex-md-nowrap flex-lg-nowrap pa-0 mb-2 dashboard-row"
    >
      <line-card v-if="!isLoading" :data="lineData"></line-card>
      <v-card
        elevation="0"
        class="rounded-xl overflow-y-auto top-products-card"
        outlined
        width="100%"
      >
        <v-card-text class="">
          <v-row>
            <v-col cols="10" class="ranking-heading text-center"
              >Top Purchased Products</v-col
            >
            <v-col cols="2" class="ranking-heading">Qty</v-col>
          </v-row>
          <v-row
            v-for="rank in productRankings"
            :key="rank.id"
            style="border-bottom: 1px lightgray solid"
          >
            <v-col cols="10" class="d-flex align-center">
              <div>
                <img
                  class="image-preview"
                  :src="getProductPictureUrlById(rank.pictureId)"
                />
              </div>
              <div>{{ rank.title }}</div>
            </v-col>
            <v-col cols="2" class="d-flex justify-end align-center ranking-qty">
              {{ rank.quantity }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <v-container fluid class="white rounded-xl vendor-table-panel">
      <v-tabs v-model="tab">
        <v-tab>Stocks</v-tab>
        <v-tab>Expenses</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <stock-list
            :stocks="filterStocks"
            @update="updateStock"
            @delete="deleteStock"
          ></stock-list>
        </v-tab-item>
        <v-tab-item>
          <expense-list :expenses="filterExpenses"></expense-list>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>
</template>
<script>
import ExpenseList from "@/components/ExpenseList.vue";
import VendorDashboardOverview from "@/components/VendorDashboardOverview.vue";
import StockList from "@/components/StockList.vue";
import backendService from "@/services/backend-service";
import generalMixin from "@/js/general-mixin";
import Decimal from "decimal.js";
import LineCard from "./LineCard.vue";
export default {
  name: "VendorDashboard",
  mixins: [generalMixin],
  components: {
    "vendor-dashboard-overview": VendorDashboardOverview,
    "line-card": LineCard,
    "stock-list": StockList,
    "expense-list": ExpenseList,
  },
  mounted: function () {
    if (this.vendor && this.vendor.id) {
      this.getDetails();
    }
  },
  props: {
    vendor: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      orders: [],
      stocks: [],
      expenses: [],
      pieData: {},
      lineData: {},
      isLoading: true,
      productRankings: [],
      selectedChild: null,
    };
  },
  computed: {
    tab: {
      get() {
        return this.$store.getters["interactStore/vendorDetailTab"];
      },
      set(val) {
        return this.$store.commit("interactStore/setVendorDetailTab", val);
      },
    },
    isOther() {
      return this.getVendorName(this.vendor.id) == "Other";
    },
    filterStocks() {
      return this.stocks.filter((e) => e.vendorId == this.vendor.id);
    },
    filterExpenses() {
      return this.expenses.filter((e) => e.vendorId == this.vendor.id);
    },
  },
  methods: {
    getDetails() {
      Promise.all([
        this.getStocksByVendorId(this.vendor.id),
        this.getExpensesByVendorId(this.vendor.id),
      ]).then(() => {
        this.getProductRankings();
        this.getLineChartData();
      });
      this.timer(2000).then(() => {
        this.isLoading = false;
      });
    },
    getLineChartData() {
      let stocks = this.stocks;
      let expenses = this.expenses;
      let data = [];
      let expenseData = [];
      let stockData = [];
      let labels = [];
      let dict = {};
      let expenseDict = {};
      let stockDict = {};
      for (let i = 0; i < stocks.length; i++) {
        let stock = stocks[i];
        let dateArr = stock.dateCreated.split("-");
        let dateStr = `${dateArr[0]}/${dateArr[1]}`;
        if (!dict[dateStr]) {
          dict[dateStr] = new Decimal(0);
        }
        if (!stockDict[dateStr]) {
          stockDict[dateStr] = new Decimal(0);
        }
        if (!expenseDict[dateStr]) {
          expenseDict[dateStr] = new Decimal(0);
        }
        let amount = Decimal.mul(stock.stockPrice, stock.quantity);
        dict[dateStr] = dict[dateStr].plus(amount);
        stockDict[dateStr] = stockDict[dateStr].plus(amount);
      }
      for (let i = 0; i < expenses.length; i++) {
        let expense = expenses[i];
        let dateArr = expense.transactionDate.split("-");
        let dateStr = `${dateArr[0]}/${dateArr[1]}`;
        if (!dict[dateStr]) {
          dict[dateStr] = new Decimal(0);
        }
        if (!stockDict[dateStr]) {
          stockDict[dateStr] = new Decimal(0);
        }
        if (!expenseDict[dateStr]) {
          expenseDict[dateStr] = new Decimal(0);
        }
        let amount = new Decimal(expense.amount);
        dict[dateStr] = dict[dateStr].minus(amount);
        expenseDict[dateStr] = expenseDict[dateStr].plus(amount);
      }
      labels = Object.keys(dict).sort();
      for (let i = 0; i < labels.length; i++) {
        data.push(parseFloat(dict[labels[i]].toFixed(2)));
        stockData.push(parseFloat(stockDict[labels[i]].toFixed(2)));
        expenseData.push(parseFloat(expenseDict[labels[i]].toFixed(2)));
      }
      let datasets = [
        {
          label: "Balance",
          borderColor: "#ff4b42",
          data: data,
          tension: 0.1,
        },
        {
          label: "Stock",
          borderColor: "#4570ff",
          data: stockData,
          tension: 0.1,
        },
        {
          label: "Expense",
          borderColor: "#ffb442",
          data: expenseData,
          tension: 0.1,
        },
      ];
      this.lineData = {
        labels: labels,
        datasets: datasets,
      };
      this.$forceUpdate();
    },

    getProductRankings() {
      let dict = {};
      for (let i = 0; i < this.stocks.length; i++) {
        let stock = this.stocks[i];
        if (!dict[stock.productId]) {
          let product = {};
          product.title = stock.productName;
          product.id = stock.productId;
          product.pictureId = stock.pictureId;
          product.quantity = 0;
          dict[product.id] = product;
        }
        dict[stock.productId].quantity += stock.quantity;
      }
      let products = Object.keys(dict).map((key) => {
        return dict[key];
      });
      products.sort((a, b) => {
        if (a.quantity < b.quantity) {
          return 1; // a comes before b
        }
        if (a.quantity > b.quantity) {
          return -1; // a comes after b
        }
        return a.title.localeCompare(b.title);
      });
      this.productRankings = products;
    },
    getProductPictureUrlById(imageId) {
      return backendService.getProductPictureUrlById(imageId);
    },
    getStocksByVendorId(vendorId) {
      return backendService.getStocksByVendorId(vendorId).then((response) => {
        this.stocks = response.data.filter((e) => e.quantity > 0);
      });
    },
    getExpensesByVendorId(vendorId) {
      return backendService.getExpensesByVendorId(vendorId).then((response) => {
        this.expenses = response.data;
      });
    },
    updateStock(selectedStock) {
      let idx = this.stocks.findIndex((e) => e.id == selectedStock.id);
      if (idx >= 0) {
        this.$set(this.stocks, idx, selectedStock);
      }
    },
    deleteStock(selectedStock) {
      this.stocks = this.stocks.filter((e) => e.id != selectedStock.id);
    },
  },
  watch: {
    vendor: function (newVal, oldVal) {
      if (newVal.id != oldVal.id) this.getDetails();
    },
  },
};
</script>
<style scoped>
.vendor-dashboard {
  max-width: none;
  width: 100%;
}
.dashboard-row {
  gap: 8px;
  max-width: none;
  width: 100%;
}
.top-products-card {
  height: 400px;
  min-width: 280px;
}
.ranking-heading {
  font-size: 18px;
  font-weight: 500;
}
.ranking-qty {
  font-size: 18px;
  font-weight: 500;
}
.vendor-table-panel {
  max-width: none;
  overflow: hidden;
}
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 100px;
  height: 100px;
}
</style>
